"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCHEME_CHOICE_FRAME = exports.CARD_FRAME = exports.CVV_FRAME = exports.EXPIRY_DATE_FRAME = exports.CARD_NUMBER_FRAME = exports.CDN = void 0;
exports.CDN = 'https://cdn.checkout.com/js/framesv2.min.js';
exports.CARD_NUMBER_FRAME = 'card-number-frame';
exports.EXPIRY_DATE_FRAME = 'expiry-date-frame';
exports.CVV_FRAME = 'cvv-frame';
exports.CARD_FRAME = 'card-frame';
exports.SCHEME_CHOICE_FRAME = 'scheme-choice-frame';
//# sourceMappingURL=config.js.map